<template>
  <div>
    <div class="home_logo" :class="{NavBg:whether}">
      <div class="padding15">
        <div class="width2 top_left">
            <router-link to="/home">
              <img src="@/assets/images/header/logo_newvi.png">
            </router-link>
        </div>
        <div class="width8 align_center">
          <div class="menu">
            <div id="index" class="head-v3">
              <div class="navigation-up">
                <div class="navigation-inner">
                  <div class="navigation-v3">
                    <ul>
                      <ul>
                        <li v-for="item in columnParentData" :key="item.id" v-bind:_t_nav="'about'+ item.id +''" :class="{nav_up_selected_inpage: ('about'+ item.id === current)?true:false}">
                          <h2><a @click="routerLinkTo(item)"> {{item.name}}</a></h2>
                        </li>
                      </ul>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="navigation-down">
          <div  v-for="item in columnChildData" :key="item[0][0].id" v-bind:id="'about'+ item[0][0].parentId +''" v-bind:_t_nav="'about'+ item[0][0].parentId +''" class="nav-down-menu menu-1" style="display: none;">
            <div style="margin-left: 30%;" class="navigation-down-inner">
              <dl v-for="childs in item" :key="childs.id">
                <dd v-for="child in childs" :key="child.id"><a @click="routerLinkTo(child)">{{child.name}}</a></dd>
              </dl>
            </div>
          </div>
        </div>
        <div class="width2 top_right align_right">
            <router-link to="/login" :class="{login_statue: (userName === '')?false:true}">登录</router-link>
            <el-dropdown :class="{login_statue: (userName === '')?true:false}" @command="handleCommand">
              <span class="el-dropdown-link">
                {{userName}}
              </span>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item command="logout">退出登录</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
            <a class="menu_search"><i class="fa fa-search"></i></a>
            <a class="menu_mobile"><i class="fa fa-mobile"></i></a>
        </div>
        <div class="clear"></div>
      </div>
    </div>
    <div class="mobile">
      <div class="mobile-inner">
        <div class="mobile-inner-header">
          <div class="phone_logo">
            <router-link to="/home">
              <img src="@/assets/images/header/logo_wihte.png">
            </router-link>
          </div>
          <div class="mobile-inner-header-icon mobile-inner-header-icon-out"><span></span><span></span></div>
        </div>
        <div class="mobile-inner-nav">
          <el-tabs tab-position="left">
            <el-tab-pane v-for="item in mobileParentData" :key="item.id" :label="item.name">
              <el-link class="mobile_nav1" @click="routerLinkTo(item)" :underline="false"> {{ item.name }}</el-link>
              <el-link v-for="child in item.children" :key="child.id" @click="routerLinkTo(child)" :underline="false"> {{ child.name }}</el-link>
            </el-tab-pane>
          </el-tabs>
        </div>
      </div>
    </div>
    <div class="black_bg"></div>
    <div class="ewm_box qrcode_box wow BounceIn animated">
      <div class="close_ewm_box">×</div>
      <div id="qrcodetop"></div>
      <p>
        打开手机，扫一扫二维码<br>
        即可通过手机访问网站
      </p>
    </div>
    <div class="ewm_box search_box wow BounceIn animated">
      <div class="close_ewm_box">×</div>
      <h2>全站搜索</h2>
      <select v-model="likeSearch.type" class="inputselect">
        <option value=0>正文与标题</option>
        <option value=1>仅搜索标题</option>
      </select>
      <input v-model="likeSearch.name" placeholder="关键字" type="text" class="inputselect">
      <a @click="toLikeSearch()">搜索</a>
    </div>
  </div>
</template>

<script>
  import { setToken, setUserInfo, getUserInfo } from '@/utils/common'
  import wowjs from '@/assets/js/wow.min.js';
  import QRCode from 'qrcodejs2';
  export default {
    name: "Vheader",
    data: function () {
      return {
        whether: false,
        current: '',
        userName: '',
        columnData: [],
        columnParentData: [{
          id: 0,
          name: '首页',
          orderId: 0,
          parentId: 0,
          state: 0,
          modified: null,
          created: null
        }],
        mobileParentData: [{
          id: 0,
          name: '首页',
          parentId: 0,
          children: []
        }],
        columnChildData: [],
        likeSearch: {
          type: 0,
          name: ''
        },
        routeHeardParams: {
          columnId: 0,
          columnName: '首页',
          parentId: 0
        }
      }
    },
    mounted() {
      this.getColumnList()
      window.addEventListener('scroll', this.handleScroll)
      this.userName = getUserInfo().userName ? getUserInfo().userName : ''
      // 监听动画
      this.$nextTick(() => { // 在dom渲染完后,再执行动画
        new wowjs.WOW({live: false}).init()
        $(".menu_search").click(function(){
          $(".black_bg").show()
          $(".search_box").show()
        })
        $(".menu_mobile").click(function(){
          $(".black_bg").show()
          $(".qrcode_box").show()
        })
        $(".close_ewm_box").click(function () {
          $(".search_box").hide()
          $(".qrcode_box").hide()
          $(".black_bg").hide()
        })
        $(".close_ewm_activity").click(function () {
          $(".black_bg").hide()
          $(".activity_box").hide()
        })
        // 手机菜单
        $(".mobile-inner-header-icon").click(function(){
          $(this).toggleClass("mobile-inner-header-icon-click mobile-inner-header-icon-out")
          $(".mobile-inner-nav").slideToggle(250)
        })
        $(".mobile-inner-nav a").each(function( index ) {
          $( this ).css({'animation-delay': (index/10)+'s'})
        })
        this.qrcodetop()
        // this.qrcodelawyer();
      })
      this.setCurrent()
    },
    methods: {
      getColumnList() {
        if(localStorage.getItem('columnListData') == null || localStorage.getItem('columnListData') == undefined){
          this.isLoading = true
          this.$axios.get(this.$apiUrl.COLUMN_PAGE_API_URL, 'Json', {
            state: 0,
            pageNo: 1,
            pageSize: 50
          })
          .then(res => {
            this.isLoading = false
            if (res.data.code == 200) {
              this.columnData = res.data.data.list
              let parentId = 0
              let child = 1
              let childs = []
              let child1 = []
              let child2 = []
              let child3 = []
              let mobileChild = []
              let mobileParent = {}
              let mobileParentMap = new Map()
              mobileParentMap.set(0, 0)
              let index = 1
              res.data.data.list.find((item)=>{
                if (item.parentId == 0) {
                  this.columnParentData.push(item)
                  mobileParent = {
                    id: 0,
                    name: '首页',
                    parentId: 0,
                    children: []
                  }
                  mobileParentMap.set(item.id, index)
                  index = index + 1
                  mobileParent.id = item.id
                  mobileParent.name = item.name
                  mobileParent.parentId = item.parentId
                  this.mobileParentData.push(mobileParent)
                } else {
                  if (item.parentId != 2) {
                    this.mobileParentData[mobileParentMap.get(item.parentId)].children.push({
                      id: item.id,
                      name: item.name,
                      parentId: item.parentId,
                    })
                    if (parentId == 0) {
                      parentId = item.parentId
                      child1.push(item)
                      child = 2
                    } else {
                      if (parentId == item.parentId) {
                        if (child == 1) {
                          child1.push(item)
                          child = 2
                        } else if (child == 2) {
                          child2.push(item)
                          child = 3
                        } else if (child == 3) {
                          child3.push(item)
                          child = 1
                        }
                      } else {
                        childs.push(child1)
                        childs.push(child2)
                        childs.push(child3)
                        this.columnChildData.push(childs)
                        childs = []
                        child1 = []
                        child2 = []
                        child3 = []
                        child = 1
                        parentId = item.parentId
                        child1.push(item)
                        child = 2
                      }
                    }
                  }
                }
              })
              childs.push(child1)
              childs.push(child2)
              childs.push(child3)
              this.columnChildData.push(childs)
              this.mobileParentData.push({
                id: 99,
                name: '全站搜索',
                parentId: 0,
                children: []
              })
              this.setColumnChildData()
              let columnListData = {
                columnParentData: this.columnParentData,
                columnChildData: this.columnChildData,
                mobileParentData: this.mobileParentData,
                columnData: this.columnData,
                time: new Date().getTime()
              }
              localStorage.setItem('columnListData', JSON.stringify(columnListData))
            } else {
              this.$message.error(res.data.msg)
            }
          }).catch(err => {
            this.isLoading = false
            this.$message.error("服务器出现差错1")
          })
        }else{
          let columnListData = JSON.parse(localStorage.getItem('columnListData'))
          this.columnParentData = columnListData.columnParentData
          this.columnChildData = columnListData.columnChildData
          this.mobileParentData = columnListData.mobileParentData
          this.columnData = columnListData.columnData
          this.setColumnChildData()
          if (columnListData.time == undefined || new Date().getTime() - columnListData.time > 30000) { // 缓存30分钟
            localStorage.clear()
          }
        }
      },
      // 滑轮事件
      handleScroll() {
        var e = document.documentElement.scrollTop
        if (!e) return
        if (e > 15) {
          this.whether = true
        } else {
          this.whether = false
        }
      },
      // 顶部二维码
      qrcodetop () {
        var qrcodecontext = document.location.href;
        qrcodecontext = qrcodecontext.substring(0, 4).toLowerCase() == "http" ? qrcodecontext : "http://" + qrcodecontext;
        var qrnode = new QRCode('qrcodetop', { correctLevel: 0, text: qrcodecontext, width: 140, height: 140, background: "#fff", foreground: "#000" });
      },
      // 栏目子菜单
      setColumnChildData () {
        var qcloud = {}
        setTimeout(function() {
          $('[_t_nav]').hover(function() {
            var _nav = $(this).attr('_t_nav')
            clearTimeout(qcloud[_nav + '_timer'])
            qcloud[_nav + '_timer'] = setTimeout(function() {
              $('[_t_nav]').each(function() {
                $(this)[_nav == $(this).attr('_t_nav') ? 'addClass' : 'removeClass']('nav-up-selected')
              })
              $('#' + _nav).stop(true, true).slideDown(200)
            }, 150)
          }, function() {
            var _nav = $(this).attr('_t_nav')
            clearTimeout(qcloud[_nav + '_timer'])
            qcloud[_nav + '_timer'] = setTimeout(function() {
              $('[_t_nav]').removeClass('nav-up-selected')
              $('#' + _nav).stop(true, true).slideUp(200)
            }, 150)
          })
        }, 100)
      },
      setCurrent () {
        var routeName = this.$route.name
        if (routeName === 'home'){
          this.current = 'about0'
        } else if (routeName === 'honors') { // 金展荣誉 => 金展荣誉
          this.current = 'about1'
        } else if (routeName === 'about') { // 关于金展、金展概况 => 金展简介
          this.current = 'about1'
        } else if (routeName === 'customer') { // 金展客户 => 金展客户
          this.current = 'about1'
        } else if (routeName === 'researchCenter') { // 南大破产研究中心 => 南大破产研究中心
          this.current = 'about1'
        } else if (routeName === 'contactUs') { // 联系我们 => 联系我们
          this.current = 'about1'
        } else if (routeName === 'lawyer' || routeName === 'lawyerDetail') { // 专家律师 => 专家律师
          this.current = 'about1'
        } else if (routeName === 'freshTalent') { // 招贤纳士 => 招贤纳士
          this.current = 'about1'
        } else if (routeName === 'bankruptcyBusiness') { // 破产业务 => 破产业务
          this.current = 'about2'
        } else if (routeName === 'bankruptcyNews') { // 破产资讯 => 破产资讯
          this.current = 'about3'
        } else if (routeName === 'lawsCases') { // 法规案例 => 法规案例
          this.current = 'about4'
        } else if (routeName === 'bankruptcyResearch') { // 破产研究 => 破产研究
          this.current = 'about5'
        } else if (routeName === 'bankruptcyAnnouncement') { // 破产公告 => 破产公告
          this.current = 'about6'
        } else if (routeName === 'periodicals') { // 金展期刊 => 金展期刊
          this.current = 'about7'
        } else if (routeName === 'columnNews' || routeName === 'columnNew') {
          let routeId = this.$route.params.id
          if (routeId == undefined) {
            this.current = 'about0'
          }
          let obj = {}
          obj = this.columnData.find((item)=>{
            return item.id == routeId
          })
          if (obj == undefined) {
            this.current = 'about0'
          } else {
            if (obj.parentId == 0) {
              this.current = 'about' + obj.id
            } else {
              this.current = 'about' + obj.parentId
            }
          }
        } else if (routeName === 'columnContent' || routeName === 'likeSearch') {
          if (!(window.sessionStorage.getItem('routeParams') == null || window.sessionStorage.getItem('routeParams') == undefined)){
            let obj = JSON.parse(window.sessionStorage.getItem('routeParams'))
            if (obj == undefined) {
              this.current = 'about0'
            } else {
              if (obj.parentId == 0) {
                this.current = 'about' + obj.columnId
              } else {
                this.current = 'about' + obj.parentId
              }
            }
          }
        }
      },
      routerLinkTo(item) {
        this.routeHeardParams.columnName = item.name
        this.routeHeardParams.columnId = item.id
        this.routeHeardParams.parentId = item.parentId
        window.sessionStorage.setItem('routeParams', JSON.stringify(this.routeHeardParams))
        if(item.id == 99) { // 全站搜索
          this.$router.push({
            name: "likeSearch",
            params: {
              searchType: 0,
              searchName: '',
              id: 0,
              name: '首页',
              parentId: 0
            }
          })
        } else {
          if (item.id == 0) { // 首页 => 首页
            this.$router.push({
              name: "home"
            })
          } else if (item.id == 1 || item.id == 8) { // 关于金展、金展概况 => 金展简介
            this.$router.push({
              name: "about"
            })
          } else if (item.id == 11) { // 金展客户 => 金展客户
            this.$router.push({
              name: "customer"
            })
          } else if (item.id == 10) { // 金展荣誉 => 金展荣誉
            this.$router.push({
              name: "honors"
            })
          } else if (item.id == 9) { // 南大破产研究中心 => 南大破产研究中心
            this.$router.push({
              name: "researchCenter"
            })
          } else if (item.id == 14) { // 联系我们 => 联系我们
            this.$router.push({
              name: "contactUs"
            })
          } else if (item.id == 12) { // 专家律师 => 专家律师
            this.$router.push({
              name: "lawyer"
            })
          } else if (item.id == 13) { // 招贤纳士 => 招贤纳士
            this.$router.push({
              name: "freshTalent"
            })
          } else {
            if (item.id == 2) {  // 破产业务 => 破产业务
              this.$router.push({
                path: '/bankruptcyBusiness/15'
              })
            } else if (item.id == 3) {  // 破产资讯 => 破产资讯
              this.$router.push({
                name: 'bankruptcyNews'
              })
            } else if (item.id == 4) {  // 法规案例 => 法规案例
              this.$router.push({
                name: 'lawsCases'
              })
            } else if (item.id == 5) {  // 破产研究 => 破产研究
              this.$router.push({
                name: 'bankruptcyResearch'
              })
            } else if (item.id == 6) {  // 破产公告 => 破产公告
              this.$router.push({
                name: 'bankruptcyAnnouncement'
              })
            } else if (item.id == 7) {  // 金展期刊 => 金展期刊
              this.$router.push({
                name: 'periodicals'
              })
            } else {  // 专栏栏目 => 专栏栏目
              if (this.$route.name == 'columnNews') {
                this.$router.push({
                  path: '/articleInformation/'+ item.id
                })
              } else {
                this.$router.push({
                  path: '/columnInformation/'+ item.id
                })
              }
            }
          }
        }
      },
      toLikeSearch() {  // 全站搜索
        $(".search_box").hide()
        $(".black_bg").hide()
        this.$router.push({
          name: "likeSearch",
          params: {
            searchType: this.likeSearch.type,
            searchName: this.likeSearch.name,
            id: 0,
            name: '首页',
            parentId: 0
          }
        })
      },
      handleCommand(event) {
        if (event == "logout") {
          setUserInfo({})
          setToken('')
          this.userName = ''
        }
      }
    },
    watch: {
      '$route' () {
        this.setCurrent()
        this.userName = getUserInfo().userName ? getUserInfo().userName : ''
      }
    }
  }
</script>

<style scoped lang="less">
  .home_logo {
    padding: 5px 0px 25px 0px;
    width: 100%;
    position: fixed;
    z-index: 99;
    background: rgba(255,255,255,0.8);
    box-sizing: border-box;
    transition: all .5s ease;
  }
  .NavBg{
    padding: 0px 0px 15px 0px;
    border-bottom: 0px #ccc solid;
    transition: all .5s ease;
  }

  .home_logo .top_left img {
    width: 100%;
    max-width: 170px;
    margin-left: 30px;
    transition: all .5s ease;
  }
  .NavBg .top_left img {
    width: 100%;
    max-width: 120px;
    margin-left: 30px;
    transition: all .5s ease;
  }

  .home_logo .top_right {
    padding-top: 35px;
    margin-right: 30px;
    transition: all .5s ease;
  }
  .NavBg .top_right {
    padding-top: 10px;
    margin-right: 10px;
    transition: all .5s ease;
  }

  .home_logo .menu {
    padding-top: 5px;
    transition: all .5s ease;
  }
  .NavBg .menu {
    padding-top: 0px;
    transition: all .5s ease;
  }

  .home_logo .top_left {
    padding-top: 20px;
  }
  .NavBg .top_left {
    padding-top: 10px;
  }

  .home_logo .align_center {
    padding-top: 15px;
    text-align: center;
  }
  .NavBg .align_center {
    padding-top: 0px;
    text-align: center;
  }

  .padding15 {
    position: relative;
    padding: 0px;
  }
  .home_logo .width2 {
    position: relative;
    z-index: 2;
  }
  img {
    display: inline-block;
    border: none;
  }
  .width2, .width8 {
    float: left;
    min-height: 1px;
  }
  .width2 {
    width: 16.6666667%;
  }
  .home_logo .width8 {
    width: 100%;
    position: absolute;
    z-index: 1;
  }
  ul {
    margin-block-start: 1em;
    margin-block-end: 1em;
    margin-inline-start: 0px;
    margin-inline-end: 0px;
    padding-inline-start: 40px;
  }
  .menu ul {
    display: inline-block;
    margin: 0;
    padding: 0;
    list-style: none;
  }
  .menu ul li {
    float: left;
  }
  li {
    list-style: none;
    display: list-item;
    text-align: -webkit-match-parent;
  }
  .menu ul li.active a {
    background: #BF2A2A;
    border-radius: 3px;
  }
  a {
    text-decoration: none;
  }
  .menu ul li a {
    display: block;
    padding: 5px 15px;
    font-size: 22px;
  }
  .home_logo .top_right {
    float: right;
  }
  .align_right {
    text-align: right;
  }
  .top_right a.active {
    color: #BF2A2A;
  }
  .top_right a {
    color: #333;
    margin-left: 15px;
    line-height: 32px;
  }
  .clear {
    clear: both;
  }
  .login_statue{display: none;}
  .head-v3{position:relative;z-index:100;min-width:1000px}
  .head-v3 .navigation-inner{margin:0 auto;width:980px;position:relative}
  .navigation-up{height:60px;background:transition;}
  .NavBg .navigation-up{height:40px;}
  .navigation-up .navigation-v3{float:left;margin-left:30px}
  .navigation-up .navigation-v3 ul{float:left}
  .navigation-up .navigation-v3 li{float:left;font:normal 16px/59px "microsoft yahei";color:#BF2A2A}
  .NavBg .navigation-up .navigation-v3 li{line-height: 39px;}
  .navigation-up .navigation-v3 .nav-up-selected{color: #BF2A2A;}
  .navigation-up .navigation-v3 .nav_up_selected_inpage{background:transition;}
  .navigation-up .navigation-v3 li h2{font-weight:normal;padding:0;margin:0}
  .navigation-up .navigation-v3 li h2 a{padding:0 15px;display:inline-block;height:60px;font-family:"microsoft yahei"}
  .NavBg .navigation-up .navigation-v3 li h2 a{height:40px;}
  .navigation-up .navigation-v3 h2 a{color:#333;}
  .navigation-up .navigation-v3 .nav_up_selected_inpage h2 a{color:#BF2A2A;}

  .navigation-down{position:absolute;top:100px;left:0px;width:100%}
  .NavBg .navigation-down{top:56px;}
  .navigation-down .nav-down-menu{width:100%;margin:0;background:rgba(255,255,255,0.5);position:absolute;top:0px}
  .navigation-down .nav-down-menu .navigation-down-inner{margin:auto;width:1200px;position:relative}
  .navigation-down .nav-down-menu dl{float:left;margin:18px 80px 18px 0}
  .navigation-down .menu-1 dl{margin:20px 80px 25px 0}
  .navigation-down .menu-1 dt{font:normal 16px "microsoft yahei";color:#61789e;padding-bottom:10px;border-bottom:1px solid #61789e;margin-bottom:10px}
  .navigation-down .menu-1 dd a{color:#333;font:normal 17px/30px "microsoft yahei"}
  .navigation-down .menu-1 dd a:hover{color:#BF2A2A}
  .navigation-down .menu-2 dd a,.navigation-down .menu-3 dd a{color:#333;font:normal 16px "microsoft yahei"}
  .el-dropdown-menu__item {
    width: 100%;
    margin-left: -40px;
  }
  .mobile_nav1 {
    font-size: 16px;
  }
  .mobile_nav1.el-link--default {
    color: #000;
  }
  @media screen and (max-width: 1200px) {
    .home_logo .top_left img {
      margin-left: 0px;
    }
    .NavBg .top_left img {
      margin-left: 0px;
    }
  }
</style>